import ExploreOurMembershipsCorporateImage from './explore-our-memberships-corporate.webp'
import ExploreOurMembershipsIndividualImage from './explore-our-memberships-individual.webp'

export {
  ExploreOurMembershipsCorporateImage,
  ExploreOurMembershipsIndividualImage,
}
